import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import ReactTelInput from 'react-telephone-input';
import 'react-telephone-input/lib/withStyles';
import flags from '../../images/flags.png'

import {preferredCountries, errorMessagesObject} from '../Commons/Constants';
import {
    createUser,
    createUser2,
    createUserVerification,
    createCompany,
    clearErrorsCreateUser,
    phoneConfirmation,
    loginUser,
    getCurrentUser
} from '../../actions/session';
import { getHeader } from "../../helper";


class Entity extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessageConfirmPassword: false,
            errorShowMessageConfirmPassword: false,

            codeSended: false,
            codeReSended: false,
            smsTime: 300,

            phone: '',
            selectedCountry: '',

            agreement: false,
            registerStatus: false,
        }
    }

    // Если пароли несопадают то идет присваивания состояния errorMessageConfirmPassword
    VerificationConfirmPassword() {
        if (this.refs.password.value === this.refs.confirmPassword.value) {
            this.setState({
                errorMessageConfirmPassword: false
            });
        } else {
            this.setState({
                errorMessageConfirmPassword: true
            });
        }
    }

    // Показывает на странице сообщение об ошибке если пароли несовпадает
    showError() {
        if (this.state.errorMessageConfirmPassword === true) {
            this.setState({
                errorShowMessageConfirmPassword: true
            });
        }
    }

    createCompany(token) {
        if(!token) return false;

        const { createCompany, getCurrentUser, history } = this.props;
        const ref = this.refs;

        const formData = new FormData();
        
        formData.append("title", ref.title.value);
        formData.append("full_title", ref.full_title.value);
        formData.append("inn", ref.inn.value);
        formData.append("ogrn", ref.ogrn.value);
        formData.append("kpp", ref.kpp.value);
        formData.append("bank_title", ref.bank_title.value);
        formData.append("bic", ref.bic.value);
        formData.append("schet", ref.schet.value);
        formData.append("korschet", ref.korschet.value);
        formData.append("ur_address", ref.ur_address.value);
        formData.append("fact_address", ref.fact_address.value);

        const config =  {
            "headers": getHeader()
        }

        createCompany(
            formData,
            config,
            () => getCurrentUser(token, history.push('/'))
        )
    }

    handleReSendCode(e) {
        e.preventDefault();
        e.stopPropagation();

        const { phoneConfirmation } = this.props;
        const username = this.refs.username.value;
        let {phone, selectedCountry, agreement, errorMessageConfirmPassword} = this.state;

        this.showError();
        if (errorMessageConfirmPassword || !agreement) return false;

        let isValid = (phone.length !== selectedCountry.format.length) ? false : true;

        this.setState({
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: (isValid) ? false : true
            }
        })

        if(!isValid) return false;

        clearInterval(this.intervalTick);

        phoneConfirmation({phone: encodeURIComponent(phone), email: username}, () => {
            this.setState(
                {codeSended: true, reSendCode: true, smsTime: 300},
                () => this.intervalTick = setInterval(() => this.tick(), 1000)
            );
        });
    }

    tick() {
        if(this.state.smsTime < 1) {
            this.setState({smsTime: 0}, () => clearInterval(this.intervalTick));
            return;
        }
        this.setState({smsTime: this.state.smsTime - 1});
    }



    handleSubmitSignUp(e) {
        e.preventDefault();

        const { createUser2, loginUser } = this.props;
        const ref = this.refs;
        let {phone, selectedCountry, agreement, errorMessageConfirmPassword} = this.state;

        this.showError();
        if (errorMessageConfirmPassword || !agreement) return false;

        let isValid = (phone.length !== selectedCountry.format.length) ? false : true;

        this.setState({
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: (isValid) ? false : true
            }
        })

        if(!isValid) return false;

        const formData = new FormData();

        formData.append("first_name", ref.first_name.value);
        formData.append("last_name", ref.last_name.value);
        formData.append("patronymic_name", ref.patronymic_name.value);
        formData.append("password", ref.password.value);
        formData.append("username", ref.username.value);
        formData.append("phone", phone);
        formData.append("phone_confirmation_key", ref.phone_confirmation_key.value);
        formData.append("is_suggest", agreement);

        createUser2(formData, (data) => {
            this.setState({codeSended: true});
            
            loginUser({
                    username: this.refs.username.value,
                    password: this.refs.password.value
                },
                '',
                (token) => this.createCompany(token)
            )
        });
    }

    handleSubmitCode(e) {
        e.preventDefault();

        const { phoneConfirmation } = this.props;
        const username = this.refs.username.value;
        let {phone, selectedCountry, agreement, errorMessageConfirmPassword} = this.state;

        this.showError();
        if (errorMessageConfirmPassword || !agreement) return false;

        let isValid = (phone.length !== selectedCountry.format.length) ? false : true;

        this.setState({
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: (isValid) ? false : true
            }
        })

        if(!isValid) return false;

        phoneConfirmation({phone: encodeURIComponent(phone), email: username}, () => {
            this.setState(
                {codeSended: true},
                () => this.intervalTick = setInterval(() => this.tick(), 1000)
            );
        });
    }

    componentWillUnmount() {
        this.props.clearErrorsCreateUser();
    }
    
    handlePhoneChange(phone, country) {
        const initCountry = Object.assign({}, this.state.selectedCountry);

        let code = "+" + country.dialCode;
        let myCode = phone.substr(0, code.length);

        let isValid = (initCountry.format && (myCode !== code || phone.length > country.format.length)) ? false : true;

        this.setState({
            phone,
            selectedCountry: country,
            fieldErrors: {
                ...this.state.fieldErrors,
                phone: isValid ? false : true
            }
        });
    }

    handlePhoneBlur(phone, country) {
        let code = "+" + country.dialCode;
        let myCode = phone.substr(0, code.length);

        let isValid = (myCode !== code || phone.length !== country.format.length) ? false : true;

        this.setState({
            phone,
            selectedCountry: country,
            fieldErrors: {
                ...this.state.fieldErrors,
                isValid: isValid ? true : false,
                phone: isValid ? false : true
            }
        });
    }

    render(){
        const { register } = this.props;
        const { errorMessage, isFetching } = register;

    	return(
            <div className="menu-content-entity menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">

                    <div className="white-block-top">
                        <h3>Данные организации</h3>
                    </div>

                    <div className="white-block-content">
                        <div className="sign-up-form-wrap">
                        {/* <form onSubmit={(event) => { this.state.codeSended ? this.handleSubmitSignUp(event) : this.handleSubmitCode(event) }}> */}
                            <form   
                                onSubmit={(e) => {
                                        this.state.codeSended
                                        ? this.handleSubmitSignUp(e)
                                        : this.handleSubmitCode(e)
                                    }}>
                                <div className="sign-up-form-wrap__second">
                                    <div className="sign-up-form-wrap__inner">
                                        <input ref='title' type="text" required placeholder="Видимое (краткое) название" className="width100"/>
                                        <input ref='full_title' type="text" required placeholder="Наименование юридического лица" className="width100"/>
                                        <input ref='inn' type="text" required placeholder="ИНН" className="width100"/>
                                        <input ref='kpp' type="text" required placeholder="КПП" className="width100"/>
                                        <input ref='bic' type="text" required placeholder="БИК" className="width100"/>
                                        <input ref='ogrn' type="text" required placeholder="ОГРН" className="width100"/>
                                        <input ref='bank_title' type="text" required placeholder="Наименование банка" className="width100"/>
                                        <input ref='korschet' type="text" required placeholder="Кор. счёт" className="width100"/>
                                        <input ref='schet' type="text" required placeholder="Номер счёта" className="width100"/>
                                        <input ref='ur_address' type="text" required placeholder="Юридический адрес" className="width100"/>
                                        <input ref='fact_address' type="text" required placeholder="Фактический адрес" className="width100"/>
                                    </div>
                                </div>

                                <div className="sign-up-form-wrap__second">
                                    <div className="semiheader">
                                        <h3>Данные администратора</h3>
                                    </div>

                                    <div className="sign-up-form-wrap__inner">
                                        <input type="text" placeholder="Фамилия" className="width100" required ref="last_name" />
                                        <input type="text" placeholder="Имя" className="width100" required ref="first_name" />
                                        <input type="text" placeholder="Отчество" className="width100" required ref="patronymic_name" />
                                        <input type="email" placeholder="Электронная почта" className="width100" required ref="username" />
                                        {
                                            errorMessage && errorMessage.username_errors
                                            ? errorMessage.username_errors.map((text, index) =>
                                                <span key={index} className="input-error-text">{text}</span>
                                            )
                                            : ''
                                        }

                                        <input type="password" placeholder="Пароль" className="width100" required onChange={() => { this.VerificationConfirmPassword() }} ref="password" />
                                        <input type="password" placeholder="Подтвердите пароль" className="width100" required onChange={() => { this.VerificationConfirmPassword() }} ref="confirmPassword" />
                                        {
                                            this.state.errorShowMessageConfirmPassword && this.state.errorMessageConfirmPassword
                                                ?
                                                (<span className="input-error-text">Пароли несовпадают</span>) : ''
                                        }

                                        {/* <div className="input-wrap width100">
                                            <input type="text" placeholder="Номер телефона" className="width100" required ref="phone" />
                                        </div> */}
                                        <div className="input-wrap width100">
                                            <ReactTelInput
                                                preferredCountries={preferredCountries}
                                                defaultCountry="ru"
                                                flagsImagePath={flags}
                                                onChange={(val, val2) => this.handlePhoneChange(val, val2)}
                                                onBlur={(val, val2) => this.handlePhoneBlur(val, val2)}
                                                />
                                        </div>
                                        {
                                            this.state.fieldErrors && this.state.fieldErrors.phone
                                            ? <span className="input-error-text">{errorMessagesObject.phone}</span>
                                            : null
                                        }

                                        {
                                            this.state.codeSended || this.state.codeReSended ?
                                            <div style={{marginTop: '15px'}}>
                                                {
                                                    this.state.smsTime < 1 ?
                                                    <button onClick={(e) => this.handleReSendCode(e)} style={{border:0,backgroundColor:'transparent',textDecoration:'underline',padding:0}}>Отправить заново</button>
                                                    :
                                                    <div>
                                                        <div className="input-success-text">Вам отпрален СМС-код, введите чтобы завершить регистрацию.</div>
                                                        <div className="input-info-text">СМС-код активен в течении {this.state.smsTime} сек.</div>
                                                    </div>
                                                }
                                            </div>
                                            : null
                                        }

                                        {
                                            this.state.codeSended ?
                                            <div>
                                                <input type="text" className="width100" placeholder="СМС-код" required ref="phone_confirmation_key" />
                                                {
                                                    errorMessage && errorMessage.phone_confirmation_key
                                                    ? errorMessage.phone_confirmation_key.map((text, index) =>
                                                        <span key={index} className="input-error-text">{text}</span>
                                                    )
                                                    : null
                                                }
                                            </div>
                                            : null
                                        }

                                        <div className="checkboxes checkboxes_align-left" style={{marginTop: '25px'}}>
                                            <label className="c-form__label" htmlFor="agreement">
                                                <label className="custom-radio">
                                                    <input
                                                        defaultChecked={this.state.agreement}
                                                        className="value"
                                                        type="checkbox"
                                                        id="agreement"
                                                        onChange={() => this.setState({agreement: !this.state.agreement})}
                                                        />
                                                    <div></div>
                                                </label>
                                                <span className="text">Я согласен с <Link to="/information/Pravila">правилами использования</Link></span>
                                            </label>
                                        </div>

                                        <div className="big-button button-action width100">
                                            {
                                                this.state.agreement ?
                                                    this.state.codeSended
                                                    ? <button className={isFetching ? 'disabled' : ''}>Зарегистрироваться</button>
                                                    : <button className={isFetching ? 'disabled' : ''}>Выслать код</button>
                                                : 
                                                <button className='disabled' disabled>{this.state.codeSended ? 'Зарегистрироваться' : 'Выслать код'}</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </form>
                            {/* <form onSubmit={this.handleVerification.bind(this)}>
                                <div>
                                    <input type="text" className="width100" placeholder="СМС-код" required ref="SMSCode" />
                                    {
                                        errorMessage && errorMessage.phone_confirmation_key
                                        ? errorMessage.phone_confirmation_key.map((text, index) =>
                                            <span key={index} className="input-error-text">{text}</span>
                                        )
                                        : ''
                                    }
                                    <div className="big-button button-action width100">
                                        <button>Зарегистрироваться</button>
                          </div>
                                </div>
                            </form> */}
                        </div>
                    </div>
                </div>
            </div>
    	)
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};
export default connect(
    mapStateToProps,
    { createUser, createUser2, createUserVerification, createCompany, clearErrorsCreateUser, phoneConfirmation, getCurrentUser, loginUser, getCurrentUser }
)(Entity);


// WEBPACK FOOTER //
// ./src/components/SignUp/Entity.js